import { FaSort, FaDownload, FaUsers } from 'react-icons/fa';
import React, { useEffect, useState } from 'react';
import { handleError } from '../utils/errorHandler';
import { colorsRangeHex, formatNumber } from '../Transversal';
import { DEFAULT_FILTER, ArcFiltros } from '../Detalles/SesionDetalles';
import { API_URL, HEIGHT_BODY, WIDTH_RIGHT_PANEL, COLOR_FONT_TITLE } from '../Config';
import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';
import { useAppState } from './GraficoContext';
import { apiFetch } from '../apiClient';

let filterregrescarFiltros = 0;

interface SumaPoblacionEtnica {
    totalPoblacion?: number;
    comunidadesNegrasAfrocolombianasRaizalesPalenqueras?: number;
    poblacionIndigena?: number;
    puebloRrom?: number;
}

interface BarraProps {
    filtrar: string;
    codigoDivipola: string;
    indicador: any
}

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

const Genero: React.FC<BarraProps> = ({ filtrar, codigoDivipola, indicador }) => {
    const { tieneEtnica, setTieneEtnica } = useAppState();
    const [sumaPoblacionEtnica, setdivipolaCantidad] = useState<SumaPoblacionEtnica>();
    const [cantidadNacional, setCantidadNacional] = useState<number>(0);
    let cargado = false;
    const fetchDatos = async () => {
        let queryString = "";
        try {
            const startTime = performance.now();
            queryString = Object.keys(DEFAULT_FILTER)
                .filter(key => DEFAULT_FILTER[key as keyof ArcFiltros] !== undefined)
                .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(DEFAULT_FILTER[key as keyof ArcFiltros] ?? '')}`)
                .join('&');
            const url = `${API_URL}/ArcIndicador/GetSumaPoblacionEtnica?${queryString}`
            const response = await apiFetch(url);
            const data = await response.json();
            const cantidadNacionalNuevo = 0;
            cargado = true;
            setCantidadNacional(cantidadNacionalNuevo);
            setdivipolaCantidad(data);
            const endTime = performance.now();
            const duration = endTime - startTime;
            console.log(`Barras Fetch duration: ${duration} ms`);
        } catch (error) {
            handleError(error);
        }
    };

    const getDatos = async () => {
        console.log(DEFAULT_FILTER);
        if (DEFAULT_FILTER.regrescarFiltros != filterregrescarFiltros) {
            filterregrescarFiltros = DEFAULT_FILTER.regrescarFiltros;
            if (indicador != "") {
                fetchDatos();
            }
        }
    }

    useEffect(() => {
        getDatos();
    }, [filtrar, codigoDivipola, indicador]);

    const total = sumaPoblacionEtnica?.totalPoblacion || 0;
    const comunidadesNegrasAfrocolombianasRaizalesPalenqueras = sumaPoblacionEtnica?.comunidadesNegrasAfrocolombianasRaizalesPalenqueras ?? null;
    const poblacionIndigena = sumaPoblacionEtnica?.poblacionIndigena ?? null;
    const puebloRrom = sumaPoblacionEtnica?.puebloRrom ?? null;

    let totalEtnica: number | null;
    if (
        comunidadesNegrasAfrocolombianasRaizalesPalenqueras == null &&
        poblacionIndigena == null &&
        puebloRrom == null
    ) {
        totalEtnica = null;
    } else {
        totalEtnica =
            ((comunidadesNegrasAfrocolombianasRaizalesPalenqueras || 0) / total) * 100 +
            ((poblacionIndigena || 0) / total) * 100 +
            ((puebloRrom || 0) / total) * 100;
    }

    useEffect(() => {
        if (isNaN(totalEtnica ?? NaN)) {
            setTieneEtnica(false);
        } else {
            setTieneEtnica(true);
        }
    }, [totalEtnica, setTieneEtnica]);

    if (isNaN(totalEtnica ?? NaN)) {
        return <div style={{ float: 'left' }}></div>;
    }
    return (
        <div style={{ alignItems: 'center', backgroundColor: '#fff', borderTop: '1px solid #ccc', float: 'left', margin: '10px 10px 0px 10px', padding: '10px 0px 0px 10px', width: '250px', borderRadius: '10px', boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', height: '220px' }}>
            <table style={{ width: '100%', height: '220px' }} cellPadding={0} cellSpacing={0}>
                <tbody>
                    <tr style={{ height: 18, textAlign: 'center', verticalAlign: 'top' }}>
                        <td colSpan={2} style={{ textAlign: 'center' }}>
                            <h3 style={{ color: "#2c66a4", fontWeight: 'bold' }}>Población Étnica</h3>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ height: 18, textAlign: 'left', verticalAlign: 'center' }}>
                            <FaUsers color="#36c" size={32} />
                        </td>
                        <td style={{ height: 18, textAlign: 'center', verticalAlign: 'top' }}>
                            <div style={{ position: 'relative', top: '0px', left: '0', fontSize: 'smaller', color: '#2c66a4', margin: 0, padding: 0 }}>Comunidades Negras</div>
                            <div style={{ position: 'relative', top: '-5px', left: '0', fontSize: 'medium', color: '#2c66a4', fontWeight: 'bold', margin: 0, padding: 0 }}>
                                {sumaPoblacionEtnica?.comunidadesNegrasAfrocolombianasRaizalesPalenqueras != null ? formatNumber(sumaPoblacionEtnica?.comunidadesNegrasAfrocolombianasRaizalesPalenqueras) : '-'}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td style={{ height: 18, textAlign: 'left', verticalAlign: 'center' }}>
                            <FaUsers color="#36c" size={32} />
                        </td>
                        <td style={{ height: 18, textAlign: 'center', verticalAlign: 'top' }}>
                            <div style={{ position: 'relative', top: '0px', left: '0', fontSize: 'smaller', color: '#2c66a4', margin: 0, padding: 0 }}>Población Indígena</div>
                            <div style={{ position: 'relative', top: '-5px', left: '0', fontSize: 'medium', color: '#2c66a4', fontWeight: 'bold', margin: 0, padding: 0 }}>
                                {sumaPoblacionEtnica?.poblacionIndigena != null ? formatNumber(sumaPoblacionEtnica?.poblacionIndigena) : '-'}
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style={{ height: 18, textAlign: 'left', verticalAlign: 'center' }}>
                            <FaUsers color="#36c" size={32} />
                        </td>
                        <td style={{ height: 18, textAlign: 'center', verticalAlign: 'top' }}>
                            <div style={{ position: 'relative', top: '0px', left: '0', fontSize: 'smaller', color: '#2c66a4', margin: 0, padding: 0 }}>Pueblo Rrom</div>
                            <div style={{ position: 'relative', top: '-5px', left: '0', fontSize: 'medium', color: '#2c66a4', fontWeight: 'bold', margin: 0, padding: 0 }}>
                                {sumaPoblacionEtnica?.puebloRrom != null ? formatNumber(sumaPoblacionEtnica?.puebloRrom) : '-'}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};

export default Genero;